import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AdminAgencyGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private auth: AuthenticationService,
    private message: NzMessageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.check(state);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.check(state);
  }

  private check(state: RouterStateSnapshot): Observable<boolean> {
    return this.auth.canAccess(['1', '3']).pipe(
      tap((allowed) => {
        if (!allowed) {
          this.router.navigate(['/fox-admin/login'], {
            queryParams: { returnUrl: state.url },
          });
          this.message.error('Bạn không có quyền truy cập.');
        }
      })
    );
  }
}
